export function zip(firstCol, ...restCols) {
    return firstCol.map((firstEl, rowIndex) => [firstEl, ...restCols.map((col) => col[rowIndex])]);
}
//# sourceMappingURL=zip.js.map